
import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import { useNavigate } from "react-router-dom"
import { useEffect } from "react"
import ResultSuccessTickMark from "../../shared/ResultSuccessTickMark"
import ResultErrorXMark from "../../shared/ResultErrorXMark"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { showRegisterModal } from "../../../features/register/registerSlice"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 600px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding: 20px;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        p{
            font-size: 16px;
            font-weight: var(--font-weight-md);
            color: ${({ theme }) => theme.mainTextColor};
            padding: 30px 0;
        }

        .link{
            background-color: #0EAC00;
            color: #fff;
            width: 310px;
            border-radius: 10px;
            width: ${({width})=> width};
            padding: 12px;
            text-align: center;
            font-size: 16px;
            line-height: 1;
            font-weight: var(--font-weight-md);
        }

    }
`
const ForgotResultModal = () => {
    const {registerResultModalData} = useSelector(state => state.register)
    const dispatch = useDispatch()
    const navigate = useNavigate()

    const { lockScroll, unlockScroll } = useScrollLock();
    
    useEffect(() => {
        const timer = setTimeout(() => {
            navigate(registerResultModalData?.routePath)
            dispatch(showRegisterModal(null))
        }, 4000);
        return () => clearTimeout(timer);
    }, []);

         //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
        lockScroll()

        return () => {
            unlockScroll()
        }
    }, [lockScroll, unlockScroll])

  return (
    <Container>
        <div className="modal" onClick={(e)=> e.stopPropagation()}>
            {
                registerResultModalData?.resultType === "success"?
                <ResultSuccessTickMark />:
                <ResultErrorXMark />
            }
            <p>{registerResultModalData?.msg}</p>

        </div>
    </Container>
  )
}

export default ForgotResultModal